import { render, staticRenderFns } from "./AnnouncementSettings.vue?vue&type=template&id=4bdf0db2&scoped=true"
import script from "./AnnouncementSettings.vue?vue&type=script&lang=js"
export * from "./AnnouncementSettings.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementSettings.vue?vue&type=style&index=0&id=4bdf0db2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdf0db2",
  null
  
)

export default component.exports